import * as React from 'react'
import {Button, Checkbox, Form, Icon, Input, Menu, Modal, Popover, Select, Spin} from "antd"

import {IBannerTemplate} from "../../store/banner/template/types"
import {Link as RouterLink, Link, RouteComponentProps, withRouter} from "react-router-dom"
import {Prompt} from 'react-router'
import styles from './TemplateEditor.module.less'
import {AdminZone} from "../../components/AccessControl"
import {
    addingNewBannerTemplateAction,
    fetchBannerTemplateByIdAsyncActions, ISetMasterActiveBannerTemplateByIdActionPayload,
    modifyingActiveBannerTemplateAction,
    saveBannerTemplateAsyncActions, setMasterActiveBannerTemplateByIdAction
} from "../../store/banner/template/actions"
import {Dispatch} from "redux"
import {withAuthorization} from "../../firebase/withAuthorization"
import {connect} from 'react-redux'
import remergeCondition from "../../firebase/conditions"
import {
    createSelectBannerTemplatesOptions,
    selectActiveBannerTemplate,
    selectActiveMasterBannerTemplate, selectHasActiveBannerTemplateChanged,
    selectIsBannerTemplateLoading, selectIsBannerTemplateSaving, selectOriginalBannerTemplate,
} from "../../store/banner/template/selectors"
import {AppState} from "../../store"
import BannerEditor from "../../components/BannerEditor/BannerEditor"
import FuseSelect, {ISelectedOption, ISelectOption} from "../../components/FuseSelect"
import {SelectValue} from "antd/lib/select"
import TemplateLinks from "./TemplateLinks"
import BasicLayout from "../../layout/BasicLayout"
import {IFeedState} from "../../store/feed/types"
import {selectFeedState} from "../../store/feed/selectors"
import * as routes from "../../constants/routes";
import layoutStyles from "../../layout/BasicLayout.module.less"

const {Option} = Select;

interface IMatchParams {
    bannerTemplateId: string
}

interface IOwnProps extends RouteComponentProps<IMatchParams> {
}

interface IStateProps {
    activeBannerTemplate: IBannerTemplate,
    originalBannerTemplate: IBannerTemplate | undefined,
    activeMasterBannerTemplate?: IBannerTemplate,
    bannerTemplateOptions: ISelectOption[]
    masterBannerTemplateOptions: ISelectOption[]
    hasChanged: boolean
    isLoading: boolean,
    isSaving: boolean,
    feed: IFeedState
}

interface IDispatchProps {
    fetchBannerTemplateById: (value: string) => void
    saveBannerTemplate: (value: IBannerTemplate) => void
    modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => void
    setMasterActiveBannerTemplateAction: (params: ISetMasterActiveBannerTemplateByIdActionPayload) => void
    addingNewBannerTemplateAction: () => void
}

const mapStateToProps = (state: AppState, props: IOwnProps): IStateProps => ({
    activeBannerTemplate: selectActiveBannerTemplate(state),
    originalBannerTemplate: selectOriginalBannerTemplate(state),
    activeMasterBannerTemplate: selectActiveMasterBannerTemplate(state),
    bannerTemplateOptions: createSelectBannerTemplatesOptions(state, false),
    masterBannerTemplateOptions: createSelectBannerTemplatesOptions(state, true),
    hasChanged: selectHasActiveBannerTemplateChanged(state),
    isLoading: selectIsBannerTemplateLoading(state),
    isSaving: selectIsBannerTemplateSaving(state),
    feed: selectFeedState(state),
});

const mapDispatchToProps = (
    dispatch: Dispatch
): IDispatchProps => {
    return {
        fetchBannerTemplateById: (value: string) => dispatch(fetchBannerTemplateByIdAsyncActions.request({id: value})),
        saveBannerTemplate: (value: IBannerTemplate) => dispatch(saveBannerTemplateAsyncActions.request({bannerTemplate: value})),
        modifyingActiveBannerTemplate: (value: Partial<IBannerTemplate>) => dispatch(modifyingActiveBannerTemplateAction({bannerTemplate: value})),
        setMasterActiveBannerTemplateAction: (params: ISetMasterActiveBannerTemplateByIdActionPayload) => dispatch(setMasterActiveBannerTemplateByIdAction(params)),
        addingNewBannerTemplateAction: () => dispatch(addingNewBannerTemplateAction()),
    }
};

type IProps = IOwnProps & IStateProps & IDispatchProps

interface IState {
    isLinkingTemplate: boolean
    isEditingTemplateInfo: boolean
    isLeavingPopupVisible: boolean
}

const leavingMessage = 'You have unsaved changes, are you sure you want to leave?';

class TemplateEditor extends React.Component<IProps, IState> {
    state: IState;

    constructor(pros: IProps) {
        super(pros);
        this.state = {
            isLinkingTemplate: false,
            isEditingTemplateInfo: false,
            isLeavingPopupVisible: false
        }
    }


    componentDidMount(): void {
        window.addEventListener("beforeunload", this.onUnload);
        if (this.props.match.params.bannerTemplateId === "copy") {

        } else if (this.props.match.params.bannerTemplateId !== "new") {
            this.props.fetchBannerTemplateById(this.props.match.params.bannerTemplateId)
        } else {
            this.props.addingNewBannerTemplateAction()
        }
    }

    componentDidUpdate(prevProps: IProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged()
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener("beforeunload", this.onUnload)
    }

    onRouteChanged() {
        if (this.props.match.params.bannerTemplateId === "new") {
            this.props.addingNewBannerTemplateAction()
        } else {
            this.props.fetchBannerTemplateById(this.props.match.params.bannerTemplateId)
        }
    }

    onUnload = (event: any) => {
        event.returnValue = leavingMessage
    };

    leaveWithoutSave = () => {

    };

    stayToSave = () => {
        this.setState({
            isLeavingPopupVisible: false
        })
    };

    onTemplateChange = (value: string): void => {
        this.props.modifyingActiveBannerTemplate({template: value})
    };

    onCustomCodeChange = (value: string): void => {
        this.props.modifyingActiveBannerTemplate({customCode: value})
    };

    onNameChange = (e: any): void => {
        this.props.modifyingActiveBannerTemplate({name: e.target.value})
    };

    onS3FolderChange = (e: any): void => {
        this.props.modifyingActiveBannerTemplate({s3Folder: e.target.value.trim()})
    };

    onToggleIsMaster = () => {
        this.props.modifyingActiveBannerTemplate({isMaster: !this.props.activeBannerTemplate.isMaster})
    };

    onSelectMasterTemplate = (value: string) => {
        this.props.modifyingActiveBannerTemplate({parentId: value});
        this.props.setMasterActiveBannerTemplateAction({id: value})
    };

    onSelectBannerTemplate = (id: SelectValue, option: ISelectedOption) => {
        this.props.history.push(`/templates/${id}`)
    };


    linkTemplate = () => {
        this.setState({
            isLinkingTemplate: true
        })
    };

    cancelLinkingTemplate = () => {
        this.setState({
            isLinkingTemplate: false
        })
    };

    finishedLinkingTemplate = () => {
        this.setState({
            isLinkingTemplate: false
        })
    };

    onToggleEditing = () => {
        this.setState({
            isEditingTemplateInfo: !this.state.isEditingTemplateInfo
        })
    };

    render() {
        // console.log("TemplateEditor render........")
        const {isMaster} = this.props.activeBannerTemplate;
        const masterTemplate = this.props.activeMasterBannerTemplate && this.props.activeMasterBannerTemplate.template;
        let template = this.props.activeBannerTemplate.template;
        let originalTemplate = this.props.originalBannerTemplate ? this.props.originalBannerTemplate.template : "";

        const templateLinks = {
            visible: this.state.isLinkingTemplate,
            onCancel: this.cancelLinkingTemplate,
            onLinksChange: this.finishedLinkingTemplate
        };

        let saveTemplateButtonText = "Save Template";
        if (this.props.isSaving) {
            saveTemplateButtonText = "Saving"
        } else if (this.props.isLoading) {
            saveTemplateButtonText = "Loading"
        }

        const templateSelect = <FuseSelect
            placeholder="Select other template..."
            options={this.props.bannerTemplateOptions}
            defaultValue={this.props.activeBannerTemplate.id}
            onSelect={this.onSelectBannerTemplate}
        />

        const sidebarBottom = <React.Fragment>
            <div className={layoutStyles.trigger}>
                <Popover content={templateSelect} title="Select Other Template" trigger="click">
                    <Icon type="search"/>
                </Popover>
            </div>
            <Menu theme="dark" mode="inline">
                <Menu.Item key="3">
                    <RouterLink to={routes.BANNER_TEMPLATE_NEW}>
                        <Icon type="plus"/>
                        <span>New Template</span>
                    </RouterLink>
                </Menu.Item>
            </Menu>
        </React.Fragment>

        const header = <React.Fragment>
            <Form layout="inline">
                <AdminZone>
                    <Form.Item>
                        <Button
                            type="primary"
                            disabled={!this.props.hasChanged}
                            onClick={() => this.props.saveBannerTemplate(this.props.activeBannerTemplate)}
                            loading={this.props.isSaving || this.props.isLoading}
                        >
                            {saveTemplateButtonText}
                        </Button>
                    </Form.Item>
                </AdminZone>
                <Form.Item label="Name">
                    <Input
                        className={styles.input}
                        placeholder="Template name"
                        onChange={this.onNameChange}
                        value={this.props.activeBannerTemplate.name}
                    />
                </Form.Item>
                <AdminZone>
                    <Form.Item label="S3 Folder">
                        <Input
                            style={{marginLeft: 10}}
                            className={styles.input}
                            placeholder="S3 Folder"
                            onChange={this.onS3FolderChange}
                            value={this.props.activeBannerTemplate.s3Folder}
                        />
                    </Form.Item>
                    <Form.Item>
                        <Checkbox
                            style={{marginLeft: 10}}
                            checked={this.props.activeBannerTemplate.isMaster}
                            onChange={this.onToggleIsMaster}
                        >
                            is master?
                        </Checkbox>
                    </Form.Item>
                    {!this.props.activeBannerTemplate.isMaster &&
                    <Form.Item label="Master">
                        <Select
                            style={{width: 220, marginLeft: 3}}
                            defaultValue={this.props.activeBannerTemplate.parentId}
                            onSelect={this.onSelectMasterTemplate}
                        >
                            {
                                Object.values(this.props.masterBannerTemplateOptions).map((item) => {
                                    return (<Option key={item.value}>{item.text}</Option>)
                                })
                            }
                        </Select>
                    </Form.Item>
                    }
                    <Form.Item>
                        <Button
                            style={{marginLeft: 10}}
                            onClick={this.linkTemplate}
                        >
                            Link Template
                        </Button>
                    </Form.Item>
                </AdminZone>
            </Form>
            {
                this.state.isLinkingTemplate &&
                <TemplateLinks {...templateLinks}/>
            }

        </React.Fragment>;
        return (
            <React.Fragment>
                <Prompt
                    when={this.props.hasChanged}
                    message={leavingMessage}
                />
                <BasicLayout header={header} sidebarBottom={sidebarBottom}>
                    <div className={styles.rootContainer}>
                        <React.Fragment>
                            {!this.props.isLoading &&
                            <BannerEditor
                                template={template}
                                originalTemplate={originalTemplate}
                                masterTemplate={masterTemplate}
                                templateDiffMode={!isMaster}
                                diffEditorReadOnly={true}
                                customCode={this.props.activeBannerTemplate.customCode}
                                feed={this.props.feed}
                                onTemplateChange={this.onTemplateChange}
                                onCustomCodeChange={this.onCustomCodeChange}
                            />
                            }
                        </React.Fragment>
                    </div>
                    <Modal
                        title="You have unsaved changes, are you sure to leave?"
                        visible={this.state.isLeavingPopupVisible}
                        onOk={this.leaveWithoutSave}
                        onCancel={this.stayToSave}
                    >
                    </Modal>
                </BasicLayout>
            </React.Fragment>
        )
    }
}

const authCondition = (authUser: any) => remergeCondition(authUser);


export default withAuthorization(authCondition)(withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(TemplateEditor)))


